// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const intro = require('./desktop.mp4')
const introMobile = require('./mobile.mp4')
const poster = require('./desktop.jpg')
const posterMobile = require('./mobile.jpg')

// const isMobile = window.innerWidth < 600
const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

export class Cover extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }

  componentDidMount() {}

  render() {
    return <div className='cover'>
      {!isIOS9 && (
        <video
          autoPlay
          muted
          playsInline
          preload
          loop
          poster={browserCheck.isMobile ? posterMobile : poster}
          ref={video => {
            if (video) {
              video.setAttribute('playsinline', '')
            }
          }}
        >
          {!browserCheck.isMobile && <source src={intro} type='video/mp4' />}
          {browserCheck.isMobile && <source src={introMobile} type='video/mp4' />}
        </video>
      )}
      {isIOS9 && <img src={poster} alt='' className='fallback' />}

      <div className='text-wrapper'>
        <h1>{this.props.title}</h1>
        <h2>{this.props.lead}</h2>
      </div>
    </div>
  }
}
